export const CLEAR_PRODUCT_FILTER = 'LS_PDP/CLEAR_PRODUCT_FILTER';
export const CLEAR_PRODUCT_FILTERS = 'LS_PDP/CLEAR_PRODUCT_FILTERS';
export const FILTER_SELECTED_PRODUCT = 'LS_PDP/FILTER_SELECTED_PRODUCT';
export const RECEIVE_COLORS = 'LS_PDP/RECEIVE_COLORS';
export const RECEIVE_MATERIALS = 'LS_PDP/RECEIVE_MATERIALS';
export const RECEIVE_SEARCH_ALTERNATIVES = 'LS_PDP/RECEIVE_SEARCH_ALTERNATIVES';
export const RECEIVE_TOTAL_ALTERNATIVES = 'LS_PDP/RECEIVE_TOTAL_ALTERNATIVES';
export const SELECT_ALT_PRODUCT = 'LS_PDP/SELECT_ALT_PRODUCT';
export const SELECT_PRODUCT = 'LS_PDP/SELECT_PRODUCT';
export const SELECT_PRODUCT_FILTER_OPTIONS = 'LS_PDP/SELECT_PRODUCT_FILTER_OPTIONS';
export const UPDATE_FILTERS_APPLIED_COUNT = 'LS_PDP/UPDATE_FILTERS_APPLIED_COUNT';
export const UPDATE_PRODUCT_QUANTITY = 'LS_PDP/UPDATE_PRODUCT_QUANTITY';
export const RESET = 'LS_PDP/RESET';

export const SEARCH_KEY = 'pdpAlternatives';

export const SET_VARIANTS_BY_ATTRIBUTE = 'SET_VARIANTS_BY_ATTRIBUTE';
export const SET_VARIANT_LOAD_STATUS = 'SET_VARIANT_LOAD_STATUS';
export const SET_VARIANT_PRODUCT_IDS = 'SET_VARIANT_PRODUCT_IDS';
export const CLEAR_VARIANT_PRODUCT_IDS = 'CLEAR_VARIANT_PRODUCT_IDS';
